var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:"reference",staticClass:"gallery-image bg-gray-200 z-40",attrs:{"src":_vm.link}})
}
var staticRenderFns = []

export { render, staticRenderFns }